import { render } from "./MenuStorageBar.vue?vue&type=template&id=1fcd794a&scoped=true"
import script from "./MenuStorageBar.vue?vue&type=script&lang=js"
export * from "./MenuStorageBar.vue?vue&type=script&lang=js"

import "./MenuStorageBar.vue?vue&type=style&index=0&id=1fcd794a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcd794a"]])

export default __exports__